// extracted by mini-css-extract-plugin
export var background = "icon-ink-module--background--zNS1b";
export var image = "icon-ink-module--image--K5DCq";
export var wrapper = "icon-ink-module--wrapper--C3IbV";